import styled from 'styled-components';
export var DatePickerContainer = styled.div.withConfig({
  displayName: "FilterValuestyles__DatePickerContainer",
  componentId: "keen-query-creator__sc-o6ruxg-0"
})(["&&&{max-width:250px;}"]);